import {
  CHANGE_IMPORTER_LAWYER_SELECTED_FILE,
  CHANGE_IMPORTER_LAWYER_CASES,
  CHANGE_IMPORTER_LAWYER_STATUS,
  CHANGE_IMPORTER_LAWYER_SUMMARY
} from './actions'

export default function (state = {
  selectedFile: '',
  headers: [
    { label: 'Status', value: 'status' },
    { label: 'Nome', value: 'name' },
    { label: 'Sobrenome', value: 'surname' },
    { label: 'Número da OAB', value: 'oabNumber' },
    { label: 'UF da OAB', value: 'oabUf' },
    { label: 'E-Mail', value: 'email', optional: true },
    { label: 'Telefone 1', value: 'tel1', optional: true },
    { label: 'Telefone 2', value: 'tel2', optional: true },
    { label: 'Telefone 3', value: 'tel3', optional: true },
  ],
  cases: [],
  status: '',
  summary: {
    total: 0,
    imported: 0,
    errors: 0,
    averageTime: 0,
    timeLeft: 0
  }
}, action) {
  switch (action.type) {
    case CHANGE_IMPORTER_LAWYER_SELECTED_FILE:
      return { ...state, selectedFile: action.payload }
    case CHANGE_IMPORTER_LAWYER_CASES:
      return { ...state, cases: action.payload }
    case CHANGE_IMPORTER_LAWYER_STATUS:
      return { ...state, status: action.payload }
    case CHANGE_IMPORTER_LAWYER_SUMMARY:
      return { ...state, summary: action.payload }
    default:
      return state
  }
}
